import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconButtonComponent } from '../../common/button/components/icon-button/icon-button.component';
import type { IconName } from '../../icons-container/icons.type';

@Component({
  selector: 'rt-sidebar-filter',
  styleUrls: ['./sidebar-filter.component.less'],
  templateUrl: './sidebar-filter.component.html',
  imports: [IconButtonComponent, NgTemplateOutlet],
})
export class SidebarFilterComponent {
  @Input() public name: string;
  @Input() public icon: IconName;
  @Input() public minimized: boolean = false;
  @Input() public contentTemplate: TemplateRef<any>;
  @Input() public contentTemplateContext: Record<string, any>;
  @Input() public removable: boolean = true;

  @Output() public remove: EventEmitter<null> = new EventEmitter();
}
